/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfessionModelSearchResultModel } from '../../models/profession-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface ProfessionSearchProfessionPost$Params {
      body?: SearchRequestModel
}

export function professionSearchProfessionPost(http: HttpClient, rootUrl: string, params?: ProfessionSearchProfessionPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ProfessionModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, professionSearchProfessionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<ProfessionModelSearchResultModel>;
    })
  );
}

professionSearchProfessionPost.PATH = '/Profession/SearchProfession';
